<template>
    <Disclosure as="nav" class="bg-white border-b border-green" v-slot="{ open }">
        <div class="container mx-auto">
            <div class="relative flex items-center justify-between h-16">
                <div class="absolute inset-y-0 left-0 flex items-center sm:hidden">
                    <!-- Mobile menu button-->
                    <DisclosureButton
                        class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                        <span class="sr-only">Open main menu</span>
                        <MenuIcon v-if="!open" class="block h-6 w-6" aria-hidden="true"/>
                        <XIcon v-else class="block h-6 w-6" aria-hidden="true"/>
                    </DisclosureButton>
                </div>
                <div class="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
                    <div class="hidden sm:block">
                        <div class="flex space-x-4">
                            <AppLink
                                v-for="link in links"
                                theme="primary-button"
                                :to="link.to">
                                {{ link.label }}
                            </AppLink>
                        </div>
                    </div>
                </div>
                <div
                    class="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0"></div>
            </div>
        </div>

        <DisclosurePanel class="sm:hidden">
            <div class="px-2 pt-2 pb-3 space-y-1">
                <AppLink
                    v-for="link in links"
                    class="block px-3 py-2 rounded-md text-base font-medium"
                    theme="primary-button"
                    :to="link.to">
                    {{ link.label }}
                </AppLink>
            </div>
        </DisclosurePanel>
    </Disclosure>
</template>

<script>

import {Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems} from '@headlessui/vue';
import {BellIcon, MenuIcon, XIcon} from '@heroicons/vue/outline';
import {mapGetters} from "vuex";
import AppLink from "@/Components/AppLink";

export default {

    name: "Navbar",

    data() {
        return {
            open: false
        }
    },

    components: {
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        BellIcon,
        MenuIcon,
        XIcon,
        AppLink
    },

    computed: {
        ...mapGetters([
            'isAdmin',
            'isTrainer',
            'isModerator',
            'isStudent',
        ]),
        isAdminRoute() {
            return this.$route.fullPath.startsWith('/admin');
        },
        links() {
            // Don't show any linked if the router isn't ready.
            if (!this.$route.matched.length) {
                return [];
            }
            const links = this.isAdminRoute ? this.adminNavigation : this.mainNavigation;

            return links.filter(link => !link.visible || link.visible());
        },
        mainNavigation() {
            return [
                {
                    label: 'Admin',
                    to: {name: "admin"},
                    visible: () => this.isAdmin || this.isTrainer || this.isModerator

                },
                {
                    label: 'Dashboard',
                    to: {name: "student.dashboard"},
                    visible: () => this.isStudent
                },
                {
                    label: 'Courses',
                    to: {name: "courses"},
                },
                {
                    label: 'Assignments',
                    to: {name: "student.assignments"},
                    visible: () => this.isStudent && !this.isAdmin && !this.isTrainer && !this.isModerator
                },
                {
                    label: 'Certificates',
                    to: {name: "student.certificates"},
                    visible: () => this.isStudent && !this.isAdmin && !this.isTrainer && !this.isModerator
                },
            ]
        },
        adminNavigation() {
            return [
                {
                    label: 'Home',
                    to: {name: "home"},
                },
                {
                    label: 'Courses',
                    to: {name: "admin.courses.index"},
                    visible: () => this.$can('viewAny', 'Courses')
                },
                {
                    label: 'Pathways',
                    to: {name: "admin.pathways.index"},
                    visible: () => this.$can('viewAny', 'Pathways')
                },
                {
                    label: 'Users',
                    to: {name: "admin.users.index"},
                    visible: () => this.$can('viewAny', 'Users')
                },
                {
                    label: 'Settings',
                    to: {name: "admin.settings.content"},
                    visible: () => this.isAdmin
                },
            ];
        }
    },

}
</script>
